<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{generator_status}}</h4>
                <p style="font-size: 12px">{{web_texts.partials.generator_status}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-clock-o fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{pot_contracted}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.pot_contracted}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-flash fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api_general}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.api_general}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api_generator}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.api_generator}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.current_tension}}</span>
          </div>
          <div class="card-block">
            <div id="tension-generator" style="height: 300px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">F1-F2</div>
                <strong>{{v12_generator}} V</strong>
              </li>
              <li>
                <div class="text-muted">F2-F3</div>
                <strong>{{v23_generator}} V</strong>
              </li>
              <li>
                <div class="text-muted">F3-F1</div>
                <strong>{{v31_generator}} V</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.active_power}}</span>
          </div>
          <div class="card-block">
            <canvas id="active-power-generator" style="height: 295px; width: 100%;"></canvas>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.active_power_now}}</div>
                <strong>{{api_generator}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.active_reactive_energy}}</span>
          </div>
          <div class="card-block">
            <div id="active-reactive-energy-generator" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.active_power_now}}</div>
                <strong>{{api_generator}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.cos_phi_2}}</span>
          </div>
          <div class="card-block">
            <canvas id="cosi-generator" style="height: 295px; width: 100%;"></canvas>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.Cos_phi}} |||</div>
                <strong>{{cosi_generator}} φ</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.monthly_active_power}}</span>
          </div>
          <div class="card-block">
            <div id="pot-act-gen" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Home';
  import trans_es from '../../../translates/es/Home';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: '',
    props: ['devices', 'master_dev'],
    data() {
      return {
        web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": {"historical_active_power_diary": "Històric diari potència activa","cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
        general: '',
        generator: '',
        generator_status: 'S/D',
        pot_contracted: 'S/D',
        class_card_color: 'card-success',
        api_general: 'S/D',
        cosi_generator: 'S/D',
        api_generator: 'S/D',
        ae_generator: 'S/D',
        ie_generator: 'S/D',
        v1_generator: 'S/D',
        v2_generator: 'S/D',
        v3_generator: 'S/D',
        v12_generator: 'S/D',
        v23_generator: 'S/D',
        v31_generator: 'S/D',
        status_generator: 'S/D',
        mdapi_generator: 'S/D'
      }
    },
    created() {
      console.log("Created Generator");
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["home","generator"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);


      var out = this;
      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.getRealTimeEventsGenerator();
      this.getHeadCardsInfo();


      var generator_interval = setInterval(function () {
        console.log("Interval Generator");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
        if (contr_rt[1] !== "generator") {
          console.log("Clear generator loop");
          clearInterval(generator_interval);
        }else {
          out.getRealTimeValues();
          out.getRealTimeEventsGenerator();
          out.getHeadCardsInfo();
        }
      }, 5000);
    },
    mounted(){
      this.getRealTimeValues(this.getGeneralGeneratorDevice());
      this.getDiaryActiveReactiveEnergy();
      this.getMonthlyActivePowerGenerator();
    },
    methods: {
      getHeadCardsInfo() {
        axios.post(constants.ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
          client_device: 'd',
          system_id: this.system.id
        }).then((response) => {
          this.pot_contracted = parseInt(response.data.pot_contracted);
        }, (response) => {
          console.log(response);
        });
      },
      getGeneralGeneratorDevice() {
        var devices = this.devices;
        for (var i = 0; i < devices.length; i++) {
          if (devices[i].name.indexOf("General") > 0) {
            this.general = devices[i];
          } else if (devices[i].name.indexOf("Grup") > 0) {
            this.generator = devices[i];
          }
        }
      },
      getRealTimeEventsGenerator() {
        var master = this.master_dev;
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master.id + '", "R$EVE_E_GrupOFF.ST"]]'
        }).then((response) => {
          if (parseInt(response.data.value) === 0) {
            this.generator_status = "Grup ON"
          } else {
            this.generator_status = "Grup OFF"
          }
        }, (response) => {
          console.log(response)
        });
      },
      getRealTimeValues() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.general.id, "API"], [this.generator.id, "COSI", "API", "AE", "IE", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31", "MDAPI"]])
        }).then((response) => {
          this.api_general = Math.round(response.data[0].value * 10) / 10;
          this.cosi_generator = Math.round(response.data[1].value * 100) / 100;
          this.api_generator = Math.round(response.data[2].value * 100) / 100;
          this.ae_generator = Math.round(response.data[3].value * 100) / 100;
          this.ie_generator = Math.round(response.data[4].value * 100) / 100;
          this.v1_generator = Math.round(response.data[5].value * 100) / 100;
          this.v2_generator = Math.round(response.data[6].value * 100) / 100;
          this.v3_generator = Math.round(response.data[7].value * 100) / 100;
          this.v12_generator = Math.round(response.data[8].value * 100) / 100;
          this.v23_generator = Math.round(response.data[9].value * 100) / 100;
          this.v31_generator = Math.round(response.data[10].value * 100) / 100;
          this.mdapi_generator = Math.round(response.data[11].value * 100) / 100;

          this.printTensionGraph();
          this.printPowerGraph();
          this.printCosiGraph();
        }, (response) => {
          console.log(response);
        });
      },
      getDiaryActiveReactiveEnergy(){
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.generator.id, "AE", "IE"]]),
          date_range: dateRanges.currentDayDaterange()
        }).then((response) => {
          this.printActiveReactiveEnergy(dataTransforms.lineDataTransformCanvasJS(response.data, "line",["E. Activa", "E. Reactiva"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      getMonthlyActivePowerGenerator(){
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.generator.id, "API"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyActivePowerGenerator(dataTransforms.lineDataTransformCanvasJS(response.data, "line",["P. Activa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      printTensionGraph() {
        try {
        var options = {
          data: [
            {
              type: "column",
              dataPoints: [
                {label: "Tensió L1", y: this.v1_generator},
                {label: "Tensió L2", y: this.v2_generator},
                {label: "Tensió L3", y: this.v3_generator}
              ]
            }
          ]
        };

        $("#tension-generator").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      },
      printPowerGraph() {
        try {
        var opts = {
          angle: -0.35, // The span of the gauge arc
          lineWidth: 0.2, // The line thickness
          radiusScale: 0.80, // Relative radius
          pointer: {
            length: 0.58, // // Relative to gauge radius
            strokeWidth: 0.029, // The thickness
            color: '#000000' // Fill color
          },
          limitMax: false,     // If false, max value increases automatically if value > maxValue
          limitMin: false,     // If true, the min value of the gauge will be fixed
          strokeColor: '#E0E0E0',  // to see which ones work best for you
          generateGradient: true,
          highDpiSupport: true,     // High resolution support
          // renderTicks is Optional
          renderTicks: {
            divisions: 4,
            divWidth: 1.1,
            divLength: 0.7,
            divColor: '#333333',
            subDivisions: 3,
            subLength: 0.5,
            subWidth: 0.6,
            subColor: '#666666'
          },
          staticLabels: {
            font: "12px sans-serif",  // Specifies font
            labels: [0, this.pot_contracted, this.pot_contracted * 1.05, this.pot_contracted * 1.5],  // Print labels at these values
            color: "#000000",  // Optional: Label text color
            fractionDigits: 0  // Optional: Numerical precision. 0=round off.
          },
          staticZones: [
            {strokeStyle: "rgb(0,255,0)", min: 0, max: this.pot_contracted, height: 1},
            {strokeStyle: "rgb(255,255,0)", min: this.pot_contracted+1, max: this.pot_contracted * 1.05, height: 1},
            {strokeStyle: "rgb(255,0,0)", min: this.pot_contracted * 1.05 +1, max: this.pot_contracted * 1.5, height: 1}
          ]
        };
        var target = document.getElementById('active-power-generator'); // your canvas element
        var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        gauge.maxValue = this.pot_contracted * 1.5; // set max gauge value
        gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
        gauge.animationSpeed = 25; // set animation speed (32 is default value)
        gauge.set(this.api_generator); // set actual value
        }catch (e){
          console.log("Catch");
        }
      },
      printActiveReactiveEnergy(data){
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX:{
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data  // random data
        };

        $("#active-reactive-energy-generator").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      },
      printCosiGraph() {
        try {
        var opts = {
          angle: -0, // The span of the gauge arc
          lineWidth: 0.2, // The line thickness
          radiusScale: 0.55, // Relative radius
          pointer: {
            length: 0.58, // // Relative to gauge radius
            strokeWidth: 0.025, // The thickness
            color: '#000000' // Fill color
          },
          limitMax: false,     // If false, max value increases automatically if value > maxValue
          limitMin: false,     // If true, the min value of the gauge will be fixed
          strokeColor: '#E0E0E0',  // to see which ones work best for you
          generateGradient: true,
          highDpiSupport: true,     // High resolution support
          // renderTicks is Optional
          renderTicks: {
            divisions: 4,
            divWidth: 1.1,
            divLength: 0.7,
            divColor: '#333333',
            subDivisions: 3,
            subLength: 0.5,
            subWidth: 0.6,
            subColor: '#666666'
          },
          staticLabels: {
            font: "12px sans-serif",  // Specifies font
            labels: [-0.95, 0.95],  // Print labels at these values
            color: "#000000",  // Optional: Label text color
            fractionDigits: 2  // Optional: Numerical precision. 0=round off.
          },
          staticZones: [
            {strokeStyle: "rgb(0,255,0)", min: -1, max: -0.95, height: 1},
            {strokeStyle: "rgb(255,0,0)", min: -0.94, max: 0.94, height: 1},
            {strokeStyle: "rgb(0,255,0)", min: 0.95, max: 1, height: 1}
          ]
        };
        var target = document.getElementById('cosi-generator'); // your canvas element
        var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        gauge.maxValue = 1; // set max gauge value
        gauge.setMinValue(-1);  // Prefer setter over gauge.minValue = 0
        gauge.animationSpeed = 1; // set animation speed (32 is default value)
        gauge.set(this.cosi_generator); // set actual value
        }catch (e){
          console.log("Catch");
        }
      },
      printMonthlyActivePowerGenerator(data){
        try {
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX:{
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data  // random data
        };

        $("#pot-act-gen").CanvasJSChart(options);
        }catch (e){
          console.log("Catch");
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// GeneratorStatus.vue?02fee2a0